/**
 * Timer-driven refreshes mark themselves so the API does not slide the session
 * forward: a tab left open is not a user being present. A user's own action
 * (opening a page, pressing Refresh) is sent without the marker.
 *
 * decision: pollsession — see decisions/pollsession.md
 */
export const BACKGROUND_POLL_HEADER = 'X-GL-Background-Poll';

export interface PollOptions {
  /** True when a timer, not the user, triggered this request. */
  background?: boolean;
}

export function getInit(opts: PollOptions = {}): RequestInit {
  return opts.background
    ? { credentials: 'include', headers: { [BACKGROUND_POLL_HEADER]: '1' } }
    : { credentials: 'include' };
}
